import { computed, useTemplateRef } from 'vue';

import { useElementSize } from '@vueuse/core/index';

import { BREAKPOINTS } from '@/utils/constants/common';

export default function useSize(key: string) {
  const el = useTemplateRef(key);
  const { width, height } = useElementSize(el);

  const isDesktopSize = computed<boolean>(() => {
    return width.value >= BREAKPOINTS.DESKTOP;
  });
  const isTabletSize = computed<boolean>(() => {
    return width.value < BREAKPOINTS.DESKTOP && width.value >= BREAKPOINTS.TABLET;
  });
  const isMobileSize = computed<boolean>(() => {
    return width.value < BREAKPOINTS.TABLET;
  });

  return {
    width,
    height,
    isDesktopSize,
    isTabletSize,
    isMobileSize,
  };
}
